import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

@Index('idx_access_logs_date', ['date'], {})
@Index('idx_access_logs_http_method', ['httpMethod'], {})
@Index('idx_access_logs_response_code', ['responseCode'], {})
@Index('idx_access_logs_user_date', ['date', 'userId'], {})
@Entity('access_logs')
export class AccessLogsEntity extends BaseEntity {
	@Column('datetime', { name: 'date', default: () => 'CURRENT_TIMESTAMP' })
	public date!: Date;

	@Column('int', { name: 'fk_user__id', unsigned: true, nullable: true })
	public userId!: number | null;

	@Column('int', { name: '_workd__user__id', unsigned: true, nullable: true })
	public workdUserId!: number | null;

	@Column('longtext', { name: 'endpointUrl' })
	public endpointUrl!: string;

	@Column('varchar', { name: 'description', nullable: true, length: 255 })
	public description!: string | null;

	@Column('varchar', { name: 'httpMethod', nullable: true, length: 10 })
	public httpMethod!: string | null;

	@Column('varchar', { name: 'origin', nullable: true, length: 255 })
	public origin!: string | null;

	@Column('varchar', { name: 'ipAddress', nullable: true, length: 45 })
	public ipAddress!: string | null;

	@Column('text', { name: 'userAgent', nullable: true })
	public userAgent!: string | null;

	@Column('json', { name: 'request', nullable: true })
	public request!: object | null;

	@Column('json', { name: 'response', nullable: true })
	public response!: object | null;

	@Column('int', { name: 'responseCode', nullable: true })
	public responseCode!: number | null;
}
